import { apiRequest } from "../index";

export const getAllAdvertisements = async ({ page = 1, limit = 10, search = "" , showRestaurants } = {}) => {
  return apiRequest(`/api/admin/advertisements?page=${page}&limit=${limit}&search=${search}&showRestaurants=${showRestaurants}`, "GET");
};

export const addAdvertisement = async (data) => {
  return apiRequest(`/api/admin/advertisements`, "POST", data);
};

export const updateAdvertisement = async (id, data) => {
  return apiRequest(`/api/admin/advertisements/${id}`, "PUT", data);
};

export const deleteAdvertisement = async (id) => {
  return apiRequest(`/api/admin/advertisements/${id}`, "DELETE");
};

export const updateBanner = async (formData) => {
  return apiRequest(`/api/admin/advertisements/settings/banner`, "PUT", formData,true );
};

export const deleteBanner = async (formData) => {
  return apiRequest(`/api/admin/advertisements/settings/banner`, "DELETE");
};

export const getBannerSettings = async (formData) => {
  return apiRequest(`/api/admin/advertisements/settings/banner`, "GET");
};